import {
  AdminCompleteRegistrationPayloadType,
  adminCompleteRegistrationApi,
} from '@/api/v1/users/adminCompleteRegistrationApi';
import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';

export const adminCompleteRegistration = async (payload: AdminCompleteRegistrationPayloadType) => {
  try {
    const response = await adminCompleteRegistrationApi(payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
